// extracted by mini-css-extract-plugin
module.exports = {"section":"UserTemplatesSection_section__DCqu_","title":"UserTemplatesSection_title__3krj4","message":"UserTemplatesSection_message__d8qTy"};